import {
    UPDATE_EMPLOYEE_BIDDABLE_PROFILE,
    UPDATE_EMPLOYEE_BIDDED_PROFILE,
} from './bidProfile.actions';
import { BidProfileStatus, BidProcessType, EmployeeBiddingStatus } from '../../../Enums';

/** @type {EmployeeBidProfile.IDetailedEmployeeBidProfile} */
const initialState = {
    profileId: '',
    creationDate: new Date(0),
    signOffDate: new Date(0),
    lastUpdate: new Date(0),
    status: BidProfileStatus.Scheduled,
    name: '',
    description: '',
    bidProcessType: BidProcessType.Preferential,
    submissionPeriodStartDate: new Date(0),
    submissionPeriodEndDate: new Date(0),
    requestPeriodStartDate: new Date(0),
    requestPeriodEndDate: new Date(0),
    employeeRank: {
        employeeId: '',
        rank: -1,
    },
    items: [],
    shifts: {},
    paycodes: {},
    scheduleSource: -1,
    hasEmployeeSubmittedDraft: false,
    employeeSubmissionStatus: EmployeeBiddingStatus.Unsubmitted,
    employeeSubmissionDate: new Date(0),
    employeeSubmissionApprovalDate: new Date(0),
    approvedItemGroupId: null,
    isRebidAllowed: false,
    isRebid: false,
    hasTemplate: false,
    rebidNumber: 0,
    warnings: [],
    anchorDay: -1,
    isEmployeeCanDeclineBid: false,
    isEnableEmployeeBidResultReport: false,
    isEnableEmployeeRankReport: false,
    employeeSequentialSchedule: null,
    submittedBy: '',
    isSelectionAmountBasedOnRanks: false,
    weeklyHours: false,
    weeklyHoursByDefault: false,
    isForeverRequestPeriod: false,
    approvedShiftlineInfos: null,
    lockedEmployeeIds: [],
    isGroupShiftlinesWithSameSchedules: true,
};

/**
 * @param {EmployeeBidProfile.IDetailedEmployeeBidProfile} state
 * @param {ShiftBidding.IAction} action
 * */
export default function employeeBiddableProfileReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case UPDATE_EMPLOYEE_BIDDABLE_PROFILE:
            return {
                ...state,
                ...payload,
            };
        case UPDATE_EMPLOYEE_BIDDED_PROFILE:
            return {
                ...state,
                ...payload,
            };
        default:
            return state;
    }
}
